import styled from "styled-components";

export const CardContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.white};
  padding: 16px;
  border-radius: 4px;
  box-shadow: rgba(3, 3, 3, 0.1) 2px 0px 10px;

  .videoThumbnail {
    flex: 0 0 120px;
    height: 67px;
    margin-right: 16px;
    border-radius: 4px;
    overflow: hidden;
    background-color: #f0f0f0;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .placeholderThumbnail {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: ${({ theme }) => theme.colors.gray};

      span {
        font-size: 24px;
        color: white;
        text-transform: uppercase;
      }
    }
  }

  .videoInfo {
    flex: 1;
    min-width: 0;
  }

  .videoHeader {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
  }

  .videoTitle {
    font-size: 16px;
    font-weight: 600;
    margin: 0;
    margin-right: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .statusBadge {
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
    text-transform: capitalize;
  }

  .statusReady {
    background-color: #e3f7e8;
    color: #178344;
  }

  .statusProcessing {
    background-color: #fff8e1;
    color: #ffa000;
  }

  .statusError {
    background-color: #ffebee;
    color: #d32f2f;
  }

  .videoMeta {
    display: flex;
    margin-bottom: 8px;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.gray};

    span {
      margin-right: 16px;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  .videoDescription {
    font-size: 14px;
    margin: 0;
    color: ${({ theme }) => theme.colors.text};
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .videoActions {
    display: flex;
    align-items: center;
    margin-left: 16px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;

    .videoThumbnail {
      flex: 0 0 auto;
      width: 100%;
      height: 120px;
      margin-right: 0;
      margin-bottom: 16px;
    }

    .videoInfo {
      width: 100%;
      margin-bottom: 16px;
    }

    .videoActions {
      margin-left: 0;
      align-self: flex-end;
    }
  }
`;
